__turbopack_context__.v({
  "dayLabel": "Lh16Oq_dayLabel" + " " + "dayLabel",
  "dayRangeBand": "Lh16Oq_dayRangeBand" + " " + "dayRangeBand",
  "wrapper": "Lh16Oq_wrapper",
  "wrapperHighlightRange": "Lh16Oq_wrapperHighlightRange",
  "wrapperInline": "Lh16Oq_wrapperInline",
  "wrapperWithMultipleMonths": "Lh16Oq_wrapperWithMultipleMonths",
  "wrapperWithWeekNumbers": "Lh16Oq_wrapperWithWeekNumbers",
});
